module.exports = __webpack_public_path__ + "img/pride_logo_1.48b21e28.png";